import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import {
    absoluteImageUrl,
    absoluteUrl,
    cleanDescription,
    seoImages,
} from '../seo';

export default function Seo({
    title,
    description,
    path = '/',
    image = seoImages.home,
    type = 'website',
    noindex = false,
    schema = [],
}) {
    const { i18n } = useTranslation();
    const language = i18n.language || 'lv';
    const metaDescription = cleanDescription(description);
    const canonicalUrl = absoluteUrl(path);
    const imageUrl = absoluteImageUrl(image);
    const robots = noindex
        ? 'noindex, nofollow'
        : 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1';

    return (
        <Helmet htmlAttributes={{ lang: language }}>
            <title>{title}</title>
            <meta name="title" content={title} />
            <meta name="description" content={metaDescription} />
            <meta name="robots" content={robots} />
            <link rel="canonical" href={canonicalUrl} />

            <meta property="og:locale" content={language === 'en' ? 'en_US' : 'lv_LV'} />
            <meta property="og:site_name" content="IGGI" />
            <meta property="og:type" content={type} />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={metaDescription} />
            <meta property="og:url" content={canonicalUrl} />
            <meta property="og:image" content={imageUrl} />
            <meta property="og:image:alt" content={title} />

            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={metaDescription} />
            <meta name="twitter:image" content={imageUrl} />

            {schema.filter(Boolean).map((schemaItem, index) => (
                <script type="application/ld+json" key={index}>
                    {JSON.stringify(schemaItem)}
                </script>
            ))}
        </Helmet>
    );
}
